import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import config from "../../config";

const howToSlice = createSlice({
  name: "howTo",
  initialState: {
    howToData: [],
    isError: false,
  },

  reducers: {
    fetchHowToSuccess: (state, action) => {
      state.isError = false;
      state.howToData = action.payload;
    },
    fetchHowToFailure: (state) => {
      state.isError = true;
    },
  },
});

export const { fetchHowToSuccess, fetchHowToFailure } = howToSlice.actions;

export const fetchHowTo = () => async (dispatch) => {
  try {
    const response = await axios.get(`${config.apiUrl}/home`);
    dispatch(fetchHowToSuccess(response.data.shop_on));
  } catch (error) {
    dispatch(fetchHowToFailure());
  }
};

export default howToSlice.reducer;
